import EmailStatus from "@mapmycustomers/shared/enum/EmailStatus";

import EmailOutboxTab from "../enums/EmailOutboxTab";

export const PAGE_SIZE = 10;

export const TAB_STATUS_MAP: Record<EmailOutboxTab, EmailStatus> = {
  [EmailOutboxTab.CANCELLED]: EmailStatus.CANCELLED,
  [EmailOutboxTab.FAILED]: EmailStatus.ERRORED,
  [EmailOutboxTab.OUTGOING]: EmailStatus.SUBMITTED,
  [EmailOutboxTab.SCHEDULED]: EmailStatus.SCHEDULED,
  [EmailOutboxTab.SENT]: EmailStatus.SENT,
};
